// utils/useBrand.ts
//
// React binding for utils/branding. Reads the user's origin from auth context
// so the name and logo update when the user switches region.

import { useMemo } from "react";
import { useAuth } from "../contexts/AuthContext";
import {
  getBrandName,
  getBrandLogo,
  getBrandLogoAlt,
  isHealJaiBrand,
  applyBrandName,
  getBrandSlug,
  getBrandSite,
} from "./branding";

export const useBrand = () => {
  const { user } = useAuth();
  const origin = (user as any)?.region as string | undefined;

  return useMemo(
    () => ({
      name: getBrandName(origin),
      logo: getBrandLogo(origin),
      logoAlt: getBrandLogoAlt(origin),
      isHealJai: isHealJaiBrand(origin),
      slug: getBrandSlug(origin),
      domain: getBrandSite(origin),
      brandText: (text: string) => applyBrandName(text, origin),
    }),
    [origin],
  );
};

export default useBrand;
